import { render, staticRenderFns } from "./SubjectTypeSave.vue?vue&type=template&id=698106ed&"
import script from "./SubjectTypeSave.vue?vue&type=script&lang=js&"
export * from "./SubjectTypeSave.vue?vue&type=script&lang=js&"
import style0 from "./SubjectTypeSave.vue?vue&type=style&index=0&id=698106ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports